<template>
    <div class="product-card">
        <!-- Product Top Section -->
        <div class="product-card-top">
            <a :href="computedProductUrl" class="product-image">
                <img
                    :src="baseImage"
                    :class="{ 'image-placeholder': !hasBaseImage }"
                    :alt="product.name"
                />
            </a>
            <!-- <p>{{ product.variant.name === 'Pre-Order' ? `Pre Order Price: ${product.variant.price.formatted}` : "" }}</p> -->
            <!-- <p>@{{ product.variant.price.formatted }}</p> -->

            <!-- Wishlist & Compare Buttons -->
            <div v-if="isShopOrUndefined" class="product-card-actions">
                <button
                    class="btn btn-wishlist"
                    :class="{ added: inWishlist }"
                    :title="$trans('storefront::product_card.wishlist')"
                    @click="syncWishlist"
                >
                    <i :class="['la-heart', inWishlist ? 'las' : 'lar']"></i>
                </button>

                <button
                    class="btn btn-compare"
                    :class="{ added: inCompareList }"
                    :title="$trans('storefront::product_card.compare')"
                    @click="syncCompareList"
                >
                    <i class="las la-random"></i>
                </button>
            </div>
            <!-- Badges -->
            <ul class="list-inline product-badge" v-if="category !== 'sell'">
                <li v-if="isPreorder" class="badge badge-primary">
                    Pre-Order
                </li>
                <template v-else>
                    <li v-if="item.is_out_of_stock" class="badge badge-danger">
                        {{ $trans("storefront::product_card.out_of_stock") }}
                    </li>
                    <li v-else-if="product.is_new" class="badge badge-primary">
                        {{ $trans("storefront::product_card.new") }}
                    </li>
                    <li
                        v-for="vari in product.variants"
                        v-if="['New', 'Pre-Owned'].includes(vari.name) && vari.is_in_stock"
                        :class="['badge', vari.name === 'New' ? 'badge-success' : 'badge-primary']"
                        :key="vari.name"
                    >
                        {{ vari.name }}
                    </li>
                    <li v-if="item.has_percentage_special_price" class="badge badge-success">
                        -{{ item.special_price_percent }}%
                    </li>
                </template>
            </ul>
        </div>

        <!-- Product Middle Section -->
        <div class="product-card-middle">
            <product-rating
                v-if="isShopOrUndefined || category === 'preorder'"
                :ratingPercent="product.rating_percent"
                :reviewCount="product.reviews.length"
            />
            <a :href="computedProductUrl" class="product-name">
                <h6>{{ product.name }}</h6>
            </a>
            <!-- Price Display -->
            <div
                class="product-price product-price-clone fz-12"
                :style="{ position: 'relative' }"
            >
                <template v-if="category === 'sell'">
                    <span class="text-left">Cash: {{ formattedPrice(product.cash_price.amount) }}</span>
                    <strong class="extra-bar-price"> &nbsp; | &nbsp; </strong>
                    <span class="text-right">Credit: {{ formattedPrice(product.credit_price.amount) }}</span>
                </template>

                <!-- <template v-else-if="category === 'preorder' || product.variants.length > 0">
                    <div v-if="product.variants.length === 0" v-html="item.preorder_price.formatted" style="position: absolute; top: -5px;"></div>
                    <div style="position: absolute; top: 15px;">
                        <p v-for="vari in product.variants" :key="vari.name">
                            <span :class="{ 'text-red': vari.is_out_of_stock }">
                                {{ vari.name }}: {{ getVariantPrice(vari) }}
                            </span>
                            <span
                                v-if="vari.special_price && vari.special_price.amount > 0"
                                class="previous-price"
                            >
                                {{ vari.price.formatted }}
                            </span>
                        </p>
                        
                    </div>
                </template> -->

                <template v-else>
                    <div v-html="item.formatted_price"></div>
                </template>
                <p v-if="isPreorder && preorderReleaseDate" class="text-white d-block preorder_release_date">Release Date: {{ formatDate(preorderReleaseDate) }}</p>
            </div>
        </div>
        

        <!-- Product Bottom Section -->
        <div class="product-card-bottom">
            <template v-if="category === 'sell'">
                <div class="product-price fz-12">
                    <span class="text-left">Cash: {{ formattedPrice(product.cash_price.amount) }}</span>
                    <strong class="extra-bar-price"> &nbsp; | &nbsp; </strong>
                    <span class="text-right">Credit: {{ formattedPrice(product.credit_price.amount) }}</span>
                </div>

                <button
                    class="btn btn-primary only-mobile-show fz-13"
                    @click="addToSell"
                >
                    <i class="las la-rupee-sign"></i> Sell Now
                </button>

                <button
                    class="btn btn-primary btn-add-to-cart"
                    :class="{ 'btn-loading': addingToCart }"
                    @click="addToSell"
                >
                    <i class="las la-rupee-sign"></i> Sell Now
                </button>
            </template>

            <template v-else-if="isPreorder">
                <!-- <div class="product-price fz-12">
                    <span class="text-left">Pre Order Price: {{ formattedPrice(product.variant.price.amount) }}</span>
                </div> -->
                <div v-if="product.variants.length === 0" class="product-price" v-html="item.formatted_price"></div>

                <div class="product-price pb-2" v-for="vari in product.variants" :key="vari.name">
                    <span :class="{ 'text-red': vari.is_out_of_stock }">
                        {{ vari.name }}: {{ getVariantPrice(vari) }}
                    </span>
                    <span v-if="vari.special_price && vari.special_price.amount > 0" class="previous-price">
                        {{ vari.price.formatted }}
                    </span>
                    <p v-if="preorderReleaseDate" class="text-white position-absolute w-100" style="font-weight:100; bottom:-9px; font-size:12px;">Release Date: {{ formatDate(preorderReleaseDate) }}</p>
                </div>

                <button
                    class="btn btn-primary only-mobile-show fz-13"
                    @click="addToPreorder"
                >
                    <i class="las la-rupee-sign"></i> Pre Order
                </button>

                <button
                    class="btn btn-primary btn-add-to-cart"
                    :class="{ 'btn-loading': addingToCart }"
                    @click="addToPreorder"
                >
                    <i class="las la-rupee-sign"></i> Pre Order
                </button>
                
            </template>

            <template v-else>
                <div v-if="product.variants.length === 0" class="product-price" v-html="item.formatted_price"></div>

                <!-- <div class="product-price" v-for="vari in product.variants" :key="vari.name">
                    <span :class="{ 'text-red': vari.is_out_of_stock }">
                        {{ vari.name }}: {{ getVariantPrice(vari) }}
                    </span>
                    <span v-if="vari.special_price && vari.special_price.amount > 0" class="previous-price">
                        {{ vari.price.formatted }}
                    </span>
                </div> -->

                <div class="product-price">
                    <span>
                        {{ priceRange }}
                    </span>
                </div>


                <!-- Add to Cart / View Options -->
                <template v-if="hasNoOption || item.is_out_of_stock">
                    <div v-if="hasPreorderVariant">
                        <button
                            class="btn btn-primary btn-add-to-cart"
                            :class="{ 'btn-loading': addingToCart }"
                            :disabled="item.is_out_of_stock"
                            @click="addToPreorder"
                        >
                            <i class="las la-cart-arrow-down"></i> {{ $trans("storefront::product_card.pre_order") }}
                        </button>

                        <button
                            class="btn btn-primary only-mobile-show fz-13"
                            :class="{ 'btn-loading': addingToCart }"
                            :disabled="item.is_out_of_stock"
                            @click="addToPreorder"
                        >
                            <i class="las la-cart-arrow-down"></i> {{ $trans("storefront::product_card.pre_order") }}
                        </button>
                    </div>

                    <div v-else>
                        <button
                            class="btn btn-primary btn-add-to-cart"
                            :class="{ 'btn-loading': addingToCart }"
                            :disabled="item.is_out_of_stock"
                            @click="addToCart"
                        >
                            <i class="las la-cart-arrow-down"></i> {{ $trans("storefront::product_card.add_to_cart") }}
                        </button>

                        <button
                            class="btn btn-primary only-mobile-show fz-13"
                            :class="{ 'btn-loading': addingToCart }"
                            :disabled="item.is_out_of_stock"
                            @click="addToCart"
                        >
                            <i class="las la-cart-arrow-down"></i> {{ $trans("storefront::product_card.add_to_cart") }}
                        </button>
                    </div>
                    
                </template>

                <template v-else>
                    <a :href="productUrl" class="btn btn-primary btn-add-to-cart">
                        <i class="las la-eye"></i> {{ $trans("storefront::product_card.view_options") }}
                    </a>

                    <a :href="productUrl" class="btn btn-primary only-mobile-show fz-12">
                        <i class="las la-eye"></i> {{ $trans("storefront::product_card.view_options") }}
                    </a>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import ProductCardMixin from "../mixins/ProductCardMixin";

export default {
    mixins: [ProductCardMixin],

    props: ["product", "category"],

    computed: {
        hasPreorderVariant() {
            return this.product.variants?.some(
                vari => vari.name === 'Pre-Order' && vari.is_in_stock
            );
        },
        isPreorder() {
            return this.category === 'preorder' || this.hasPreorderVariant || this.product.variant?.name === 'Pre-Order';
        },
        preorderReleaseDate() {
            if (this.product.variant && this.product.variant.name === 'Pre-Order' && this.product.variant.special_price_end) {
                return this.product.variant.special_price_end;
            }
            const preorderVariant = this.product.variants?.find(v => v.name === 'Pre-Order');
            if (preorderVariant && preorderVariant.special_price_end) {
                return preorderVariant.special_price_end;
            }
            if (this.product.special_price_end) {
                return this.product.special_price_end;
            }
            return null;
        },
        item() {
            return this.product.variant || this.product;
        },
        isShopOrUndefined() {
            return typeof this.category === "undefined" || this.category === "shop";
        },
        computedProductUrl() {
            const refParam =
            this.category === "sell"
                ? (this.product.variant ? "&ref=sell" : "?ref=sell")
                : this.category === "preorder"
                ? (this.product.variant ? "&ref=preorder" : "?ref=preorder")
                : "";
            return this.productUrl + refParam;
        },

        priceRange() {
        if (!this.product.variants || this.product.variants.length === 0) return '';

            const prices = this.product.variants.map(vari => {
                // Use special price if available, otherwise regular price
                return vari.special_price && vari.special_price.amount > 0
                    ? vari.special_price.amount
                    : vari.price.amount;
            });

            const min = Math.min(...prices);
            const max = Math.max(...prices);

            // If min and max are the same, show a single price
            if (min === max) {
                return `${this.formatPrice(min)}`;
            } else {
                return `${this.formatPrice(min)} - ${this.formatPrice(max)}`;
            }
        }
    },

    methods: {
        formatDate(dateStr) {
            if (!dateStr) return 'N/A';
            const d = new Date(dateStr);
            return d.toLocaleDateString('en-GB'); // outputs "30/09/2025"
        },
        formattedPrice(amount) {
            return parseFloat(amount).toFixed(2);
        },
        getVariantPrice(vari) {
            return vari.special_price && vari.special_price.amount > 0
                ? vari.special_price.formatted
                : vari.price.formatted;
        },
        formatPrice(amount) {
            // Customize as needed; here's a simple formatter
            return `₹${amount.toFixed(2)}`;
        }
    },
};
</script>

<style scoped>
.text-red {
    color: red;
}
.product-card .product-card-middle {
    padding-bottom: 30px;
}
</style>
